import { render, staticRenderFns } from "./SocialRevenueMatrix.vue?vue&type=template&id=4256ab36&scoped=true&"
import script from "./SocialRevenueMatrix.vue?vue&type=script&lang=js&"
export * from "./SocialRevenueMatrix.vue?vue&type=script&lang=js&"
import style0 from "./SocialRevenueMatrix.vue?vue&type=style&index=0&id=4256ab36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4256ab36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VCard,VCardText,VDataTable,VIcon,VProgressCircular})
